import Summary from "./bodyComponent/Summary";

function App() {
    return (
        <Summary/>
    );
}

export default App;
